module.exports = "/images/ye-lai-qing.jpg?09d985a1937b3e4aff337e59c0a3b469";